module.exports = __webpack_public_path__ + "static/img/horse.3b4de66.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/horse.png
// module id = rAMq
// module chunks = 0